import { DOMAIN_TYPE_OPPOSITE_PARTY } from '../../../consts';
/**
 * @param state
 */
export var getOppositeParty = function (state) {
    return state.domain[DOMAIN_TYPE_OPPOSITE_PARTY];
};
